import styled from 'styled-components';

export const List = styled.div`
  margin-bottom: calc(var(--xs-padding-vertical) * 2);
`;

export const ListLabel = styled.div`
  display: block;
  width: 100%;
  margin-bottom: var(--form-label-margin-bottom, 2px);
  font-size: var(--form-label-font-size, var(--xs-font-size));
  font-weight: bold;
  text-transform: var(--form-label-text-transform, uppercase);
`;

export const ContactRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: var(--xs-padding-vertical);

  > :first-child {
    flex: 1;
  }

  .form-input {
    margin-bottom: 0;
  }
`;

export const PrimaryRadio = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: ${({ $active }) => ($active ? 'var(--orange)' : 'var(--bg)')};
  color: ${({ $active }) => ($active ? '#fff' : 'var(--text-muted)')};
  cursor: pointer;
  font-size: 0.65rem;
  transition:
    background 0.15s,
    color 0.15s;

  &:hover {
    background: ${({ $active }) => ($active ? 'var(--orange)' : 'var(--bg-3)')};
  }
`;

export const RemoveButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  border-radius: 2px;
  background: none;
  color: var(--text);
  cursor: pointer;
  transition: all 0.15s;

  &:hover:not(:disabled) {
    color: var(--error);
    background-color: color-mix(in srgb, var(--error) 8%, transparent);
  }

  &:disabled {
    opacity: 0.2;
    cursor: not-allowed;
  }
`;

export const AddButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  border: none;
  background: transparent;
  color: var(--link);
  font-size: var(--sm-font-size);
  font-weight: 500;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;
